import * as CommonActions from "./commonActions";

export default CommonActions;
